import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function FullPageSpinner({ label }: { label?: string }) {
  const { t } = useTranslation('common')

  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-3"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="text-muted-foreground size-6 animate-spin" aria-hidden />
      <p className="text-muted-foreground text-sm">{label ?? t('state.loading')}</p>
    </div>
  )
}
